import { Component, OnInit } from '@angular/core';
import {
  AUTO_STYLE,
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';

const DEFAULT_DURATION = 250;

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
  animations: [
    trigger('collapse', [
      state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
      state('true', style({ height: '0', visibility: 'hidden' })),
      transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in')),
      transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out'))
    ])
  ]
})
export class LandingPageComponent implements OnInit {

  answer1: boolean = false;
  answer2: boolean = false;
  answer3: boolean = false;
  answer4: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  toggleAnswer(answer: any) {
    if(answer == 1) {
      this.answer1 = !this.answer1;
    }
    else if(answer == 2) {
      this.answer2 = !this.answer2;
    }
    else if(answer == 3) {
      this.answer3 = !this.answer3;
    }
    else if(answer == 4) {
      this.answer4 = !this.answer4;
    }
  }

  goToSignUp() {
    window.location.href = '/create-store';
  }

  goToFaq() {
    window.location.href = '/faq';
  }

}
